function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6.7,
  y: 6.9,
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  width: 86.2,
  height: 131
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M55.2,123.3c-0.9,0-1.5-0.4-1.8-1.2c-0.5-1.2,0.2-2.9,2-4.6c1.4-1.3,3.3-2.4,5.7-3.3c1.3-2.4,2.4-4.9,3.3-7 c-1.8-2.8-2.2-6.3-1.5-8.3c0.4-1.3,1.1-1.7,1.6-1.9c0.7-0.2,1.5-0.1,2,0.5c0.8,0.8,1.1,2.5,0.9,5.2c-0.1,1.1-0.4,2.5-1,4.2 c0,0,0.1,0.1,0.1,0.1c0.4,0.5,0.9,1.1,1.3,1.6c1,1.2,2.1,2.6,3.2,3.9c0.3,0,0.7,0,1,0c4,0,6.6,0.8,7.5,2.3c0.4,0.6,0.4,1.4,0,2 c-0.5,0.8-1.5,1.3-2.8,1.3h0c-0.3,0-0.6,0-0.9-0.1c-1.6-0.3-3.3-1.5-5.5-3.8c-0.5,0-1.1,0.1-1.7,0.1c-1.3,0.1-3.7,0.4-6.2,1.2 c-1.1,1.9-3.3,5.8-5.1,6.9C56.5,123.1,55.8,123.3,55.2,123.3z M59.6,116.8c-1.2,0.6-2.2,1.3-3,2c-1.5,1.5-1.6,2.5-1.6,2.7 c0,0.1,0.1,0.1,0.2,0.1c0.3,0,0.6-0.1,1-0.4C57,120.7,58.2,119,59.6,116.8z M72.5,114.4c1.3,1.2,2.4,1.9,3.4,2.1 c0.2,0,0.4,0.1,0.6,0.1c0,0,0,0,0,0c0.7,0,1.1-0.2,1.3-0.5c0,0,0.1-0.1,0-0.2C77.5,115.3,76,114.5,72.5,114.4z M65.5,108.9 c-0.6,1.5-1.4,3.1-2.2,4.7c2-0.5,3.8-0.7,4.9-0.8c0.1,0,0.3,0,0.4,0c-0.8-1-1.6-2-2.4-2.9C66,109.5,65.7,109.2,65.5,108.9z  M65,98.7C65,98.7,65,98.7,65,98.7c-0.3,0.1-0.5,0.4-0.6,0.8c-0.4,1.3-0.3,3.5,0.6,5.5c0.3-0.9,0.4-1.7,0.5-2.3 C65.7,99.7,65.3,98.9,65,98.7C65.1,98.7,65,98.7,65,98.7z"
}));

var _ref4 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 19.5,
  y1: 43.1,
  x2: 75.2,
  y2: 43.1
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 19.5,
  y1: 46.8,
  x2: 79.6,
  y2: 46.8
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 19.5,
  y1: 50.5,
  x2: 28.8,
  y2: 50.5
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 19.5,
  y1: 59.5,
  x2: 75.2,
  y2: 59.5
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 19.5,
  y1: 63.1,
  x2: 54.2,
  y2: 63.1
});

var _ref9 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  fill: "#0F63F2",
  d: "M20,37.6V22.5h3.4c0.8,0,1.5,0,2,0.1c0.5,0.1,1,0.3,1.4,0.5c0.6,0.3,1,0.8,1.4,1.4c0.4,0.6,0.5,1.4,0.5,2.2 c0,1.7-0.6,2.9-1.9,3.6c-0.8,0.4-1.8,0.7-3.2,0.7h-2.6v6.6H20z M20.9,30.2h2.3c1.3,0,2.3-0.2,3-0.6c0.4-0.2,0.8-0.6,1-1 c0.3-0.6,0.5-1.2,0.5-1.9c0-0.7-0.2-1.3-0.5-1.9c-0.4-0.7-1.1-1.2-2-1.4c-0.4-0.1-1-0.1-1.9-0.1h-2.4V30.2z"
}), React.createElement("path", {
  fill: "#0F63F2",
  d: "M31,37.6V22.5h3.4c1.1,0,2.1,0.1,2.8,0.4c1.3,0.5,2.3,1.5,3,3c0.5,1,0.7,2.4,0.7,3.9c0,2.9-0.7,5-2.1,6.3 c-1.1,1-2.5,1.4-4.3,1.4H31z M31.9,36.8h2.5c1.7,0,2.9-0.4,3.7-1.2c1.2-1.2,1.8-3.1,1.8-5.7c0-2.5-0.6-4.3-1.8-5.4 c-0.9-0.8-2.1-1.2-3.7-1.2h-2.6V36.8z"
}), React.createElement("path", {
  fill: "#0F63F2",
  d: "M43.6,37.6V22.5h8.1v0.8h-7.2v6.1H51v0.8h-6.4v7.4H43.6z"
}));

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 150",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.c5cfce38.svg";
export { ForwardRef as ReactComponent };